let status = [
    'active', 'inactive'
]

export default status
